import { Dispatch, SetStateAction } from 'react'
import { Formik, FormikHelpers } from 'formik'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import { H4 } from 'components/Typography'
import { teamAddUserModalMessages } from './messages'
import { Close as CloseIcon } from 'components/Icons'
import BaseUniversalModal from 'components/Modal/BaseUniversalModal'
import { fieldsMessages } from 'components/Fields/messages'
import { AddUserModalFormValues, MappedDomainUser } from 'features/team/types'
import AddUserModalForm from './AddUserModalForm'
import {
  AddUserModalCloseBtn,
  AddUserModalContainer,
  AddUserModalHeader,
} from './styles'

interface AddUserModalProps {
  handleSubmit: (
    values: AddUserModalFormValues,
    { setSubmitting, setStatus }: FormikHelpers<AddUserModalFormValues>
  ) => void
  setIsAddUserModalOpen: Dispatch<SetStateAction<boolean>>
  selectedDomainName: string
  domainUsersList: MappedDomainUser[]
  hasDomainNesting: boolean
}

const initialValues = {
  email: '',
  firstName: '',
  lastName: '',
  admin: false,
  config: false,
  subscriptionManagement: false,
}

// todo: handle error - User currently inherits greater permissions on the requested domain
function AddUserModal({
  handleSubmit,
  setIsAddUserModalOpen,
  selectedDomainName,
  domainUsersList,
  hasDomainNesting,
}: AddUserModalProps) {
  const { formatMessage } = useIntl()

  const schema = Yup.object().shape({
    email: Yup.string()
      .max(255)
      .email(formatMessage(fieldsMessages.invalidEmail))
      .required(formatMessage(fieldsMessages.requiredField)),
    firstName: Yup.string().max(255),
    lastName: Yup.string().max(255),
    admin: Yup.boolean(),
    config: Yup.boolean(),
    subscriptionManagement: Yup.boolean(),
  })

  return (
    <BaseUniversalModal
      isOpen
      onRequestClose={() => setIsAddUserModalOpen(false)}
    >
      <AddUserModalContainer>
        <AddUserModalHeader>
          <H4>
            {formatMessage(teamAddUserModalMessages.title, {
              selectedDomainName,
            })}
          </H4>
          <AddUserModalCloseBtn onClick={() => setIsAddUserModalOpen(false)}>
            <CloseIcon />
          </AddUserModalCloseBtn>
        </AddUserModalHeader>

        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          validateOnMount
          initialStatus={{
            isUserAlreadyAdded: false,
            isNewUser: false,
            isError: false,
          }}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <AddUserModalForm
            setIsAddUserModalOpen={setIsAddUserModalOpen}
            domainUsersList={domainUsersList}
            hasDomainNesting={hasDomainNesting}
          />
        </Formik>
      </AddUserModalContainer>
    </BaseUniversalModal>
  )
}

export default AddUserModal
